import React from "react";
const logos = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_vision_icon.png",
  alt: "Visão Estratégica"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/leadership_experience_icon.png",
  alt: "Experiência em Liderança"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/professional_development_icon.png",
  alt: "Desenvolvimento Profissional"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/strategic_networking_icon.png",
  alt: "Networking Estratégico"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/corporate_guidance_icon.png",
  alt: "Orientação Corporativa"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_longevity_icon.png",
  alt: "Longevidade Executiva"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/masterpro_edge_icon.png",
  alt: "Diferencial MasterPro"
}];
export default function ClientLogos() {
  return;
}